import {  NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { RouterModule } from "@angular/router";

import { ViewerComponent } from "./viewer.component";

@NgModule({
    imports: [
        CommonModule,
        RouterModule.forChild([{
            path: '', component: ViewerComponent
        }])
    ],
    declarations: [
        ViewerComponent
    ],
   
})
export class ViewerModule{}